import React from "react";
import "./TradesWindow.css"
import GameWindowHeader from "../GameWindowHeader";
import GameTabViewUI from "../Tabs/GameTabViewUI";
import GameWindowBg from "../GameWindowBg";
import InGameValueCard from "../InGameValueCard";
import GameButtonWithText from "../GameButtonWithText";
import {GREEN_GRADIENT, RED_GRADIENT} from "../GameStyleUI";
import agent from "../../../agent";
import GameData from "../../../gameplay/model/GameData";
import {CLIENT_NAMES, DAY_NAMES} from "../../../constants/Constants";

const PlaceData = {
  0: {type: "station", id: 0},
  1: {type: "station", id: 1},
  2: {type: "station", id: 2},
  3: {type: "station", id: 3},
  4: {type: "reairshop", id: 0},
  5: {type: "reairshop", id: 1},
  6: {type: "reairshop", id: 2},
  7: {type: "dispetcher", id: 0},
}
const MIL = 1000000;
const DayData = [
  `${DAY_NAMES[2]} ${1}Г`,
  `${DAY_NAMES[3]} ${1}Г`,
  `${DAY_NAMES[0]} ${2}Г`,
  `${DAY_NAMES[1]} ${2}Г`,
  `${DAY_NAMES[2]} ${2}Г`,
  `${DAY_NAMES[3]} ${2}Г`,
  `${DAY_NAMES[0]} ${3}Г`,
  `${DAY_NAMES[1]} ${3}Г`,
  `${DAY_NAMES[2]} ${3}Г`,
  `${DAY_NAMES[3]} ${3}Г`
]

export default class TradesWindow extends React.Component {
  constructor() {
    super();

    this.state = {
      currentPage: 0,
      selectedTeam: 0,
      sellLocoData: {
        cost: 0,
        stationId: 0,
        locoType: "electro"
      },
      rentLocoData: {
        cost: 0,
        stationId: 0,
        locoType: "electro",
        days: 0,
        destinationStationId: 0,
        penalty: 0
      },
      rentBrigade: {
        cost: 0,
        type: "station",
        id: 0,
        days: 0,
        count: 0
      },
      rentStationPlace: {
        cost: 0,
        station: 0,
        client: "ap",
        days: 0,
        count: 0
      },
      orderData: {
        code: "CRF",
        client: "craft",
        fromId: 0,
        toId: 0,
        trainCarType: "craft",
        weight: 0,
        day: 2,
        year: 0,
        name: "",
        clientName: "",
        termDelivery: 2,
        credit: 0,
        cost: 0
      },
      sellTrainCarData: {
        cost: 0,
        stationId: 0,
        count: 0
      },
      redemptionTrainCarData: {
        cost: 0,
        stationId: 0,
        count: 0
      },
      rentTrainCarData: {
        cost: 0,
        stationId: 0,
        count: 0,
        days: 0
      }
    };
  }

  openTradingPage(page) {
    this.setState({
      selectedTeam: 0,
      currentPage: page
    })
  }

  onCancel() {
    this.props.onHide();
  }

  onOk() {
    let teams = this.props.teams;
    let teamId = teams[this.state.selectedTeam].uuid;
    let data = GameData.CurrentModeratorGameDatas[teamId];
    switch (this.state.currentPage) {
      case 0:
        if (this.state.sellLocoData.locoType !== null) {
          agent.GamePlay.sellLoco(teamId, this.state.sellLocoData, resp => {
            console.log(resp)
          });
        }
        break;
      case 1:
        agent.GamePlay.rentLoco(teamId, this.state.rentLocoData, resp => {
          console.log(resp)
        });
        break;
      case 2:
        agent.GamePlay.rentBrigade(teamId, this.state.rentBrigade, resp => {
          console.log(resp)
        });
        break;
      case 3:
        agent.GamePlay.rentStationPlace(teamId, this.state.rentStationPlace, resp => {
          console.log(resp)
        });
        break;
      case 4:
        let orders = data.thisYearOrder.filter(x => x.code.includes("CRF"));
        let state = this.state;
        state.orderData.code = "CRF" + (orders.length + 1);
        this.setState(state);
        agent.GamePlay.createOrder(teamId, this.state.orderData, resp => {
          console.log(resp)
        });
        break;
      case 5:
        agent.GamePlay.sellTrainCar(teamId, this.state.sellTrainCarData, resp => {
          console.log(resp)
        });
        break;
      case 6:
        let station = data.getStationByID(this.state.redemptionTrainCarData.stationId);
        let trainCarsCount = 0;
        if (data.state === 2) {
          for (let i = 0; i < station.orderTrainPacks.length; i++) {
            let pack = data.getOrderTrainCarById(station.orderTrainPacks[i]);
            trainCarsCount += pack.trainCarCount;
          }
        }
        if (station.trainCars - trainCarsCount < this.state.redemptionTrainCarData.count) {
          alert("На данной станции у команды недостаточно свободных вагонов для выкупа.");
          return
        }
        agent.GamePlay.redemptionTrainCar(teamId, this.state.redemptionTrainCarData, resp => {
          console.log(resp)
        });
        break;
      case 7:
        agent.GamePlay.rentTrainCar(teamId, this.state.rentTrainCarData, resp => {
          console.log(resp)
        });
        break;
      default:
        break;
    }
    this.props.onHide();
  }

  getRightPage() {
    let content = "";
    let teams = this.props.teams.map(el => el.name);

    switch (this.state.currentPage) {
      case 0:
        content = this.buildSellLocoView(teams);
        break;
      case 1:
        content = this.buildRentLocoView(teams);
        break;
      case 2:
        content = this.buildRentBrigadeView(teams);
        break;
      case 3:
        content = this.buildRentPlaceView(teams);
        break;
      case 4:
        content = this.buildCraftOrderView(teams);
        break;
      case 5:
        content = this.buildSellTrainCarView(teams);
        break;
      case 6:
        content = this.buildRedemtionTrainCarView(teams);
        break;
      case 7:
        content = this.buildRentTrainCarView(teams);
        break;
      default:
        break;
    }

    content = <div className="tradesWindow__screen">
      {content}

      <div className="tradesWindow__bottom">
        <GameButtonWithText
          width={118} height={40} title={"Отмена"}
          colorStart={RED_GRADIENT[0]} colorEnd={RED_GRADIENT[1]}
          onClick={this.onCancel.bind(this)}/>

        <GameButtonWithText
          width={118} height={40} title={"Создать"}
          colorStart={GREEN_GRADIENT[0]} colorEnd={GREEN_GRADIENT[1]}
          onClick={this.onOk.bind(this)}/>
      </div>
    </div>;

    return content;
  }

  render() {
    let content = this.getRightPage();

    return <div className="tradesWindow">
      <div className="tradesWindow__content">
        <GameWindowHeader title="продажа, заказы и аренда" isClosable={true} onHide={this.props.onHide}
                          width={1220} height={40}/>

        <div className="tradesWindow__body">
          <GameTabViewUI
            width={1200}
            height={70}
            tabs={["продажа локомотивов",
              "аренда локомотивов",
              "аренда бригады",
              "аренда места",
              "крафтовый заказ",
              "продажа вагонов",
              "выкуп вагонов",
              "аренда вагонов"
            ]}
            onSelectedIndex={this.openTradingPage.bind(this)}/>
          <GameWindowBg width={1200} height={550} value={content}/>
        </div>
      </div>
    </div>;
  }

  buildSellLocoView(teams) {
    return <div className="tradesWindow__top">
      <InGameValueCard
        title={"Команда"} isEditable={true} selectData={teams} height={40} type={1}
        subtype={2}
        onChange={value => {
          this.setState({
            selectedTeam: value || 0
          });
        }}
      />

      <div className="filler" style={{marginTop: "20px"}}/>
      <InGameValueCard
        title={"Тип локомотива"} isEditable={true}
        selectData={['Электровоз', "Тепловоз"]} height={40} type={1} subtype={2}
        onChange={value => {
          let data = this.state.sellLocoData;
          data.locoType = value === 0 ? "electro" : "loco"
          this.setState({
            sellLocoData: data
          });
        }}
      />
      <InGameValueCard
        title={"Цена (млн)"} maxValue={1000} minValue={0} isEditable={true} value={1000000} height={40}
        type={1} subtype={1}
        onChange={value => {
          let data = this.state.sellLocoData;
          data.cost = (parseInt(value) * MIL) || 0;
          this.setState({
            sellLocoData: data
          });
        }}
      />
      <InGameValueCard
        title={"Станция"} isEditable={true}
        selectData={["Анино", 'Коршуново', "Архиповка", "Озёрная"]} height={40}
        type={1} subtype={2}
        onChange={value => {
          let data = this.state.sellLocoData;
          data.stationId = value || 0;
          this.setState({
            sellLocoData: data
          });
        }}
      />
    </div>
  }

  buildRentLocoView(teams) {
    return <div className="tradesWindow__top">
      <InGameValueCard
        title={"Команда"} isEditable={true} selectData={teams} height={40} type={1}
        subtype={2}
        onChange={value => {
          this.setState({
            selectedTeam: value || 0
          });
        }}
      />

      <div className="filler" style={{marginTop: "20px"}}/>
      <InGameValueCard
        title={"Тип локомотива"} isEditable={true}
        selectData={['Электровоз', "Тепловоз"]} height={40} type={1} subtype={2}
        onChange={value => {
          let data = this.state.rentLocoData;
          data.locoType = value === 0 ? "electro" : "loco"
          this.setState({
            rentLocoData: data
          });
        }}
      />
      <InGameValueCard
        title={"Цена (млн)"} maxValue={1000} minValue={0} isEditable={true} value={1000000} height={40}
        type={1} subtype={1}
        onChange={value => {
          let data = this.state.rentLocoData;
          data.cost = (parseInt(value) * MIL) || 0;
          this.setState({
            rentLocoData: data
          });
        }}
      />
      <InGameValueCard
        title={"Срок"} isEditable={true} minValue={0} value={10} height={40} type={1} subtype={2}
        onChange={value => {
          let data = this.state.rentLocoData;
          data.days = parseInt(value) || 0;
          this.setState({
            rentLocoData: data
          });
        }}
      />
      <InGameValueCard
        title={"Станция появления"} isEditable={true}
        selectData={["Анино", "Коршуново", "Архиповка", "Озёрная"]} height={40}
        type={1} subtype={1}
        onChange={value => {
          let data = this.state.rentLocoData;
          data.stationId = value || 0;
          this.setState({
            rentLocoData: data
          });
        }}
      />
      <InGameValueCard
        title={"Станция возврата"} isEditable={true}
        selectData={["Анино", 'Коршуново', "Архиповка", "Озёрная"]} height={40}
        type={1} subtype={2}
        onChange={value => {
          let data = this.state.rentLocoData;
          data.destinationStationId = value || 0;
          this.setState({
            rentLocoData: data
          });
        }}
      />
      <InGameValueCard
        title={"Штраф (млн)"} maxValue={1000} minValue={0} isEditable={true} value={1000000} height={40}
        type={1} subtype={1}
        onChange={value => {
          let data = this.state.rentLocoData;
          data.penalty = (parseInt(value) * MIL) || 0;
          this.setState({
            rentLocoData: data
          });
        }}
      />
    </div>
  }

  buildRentBrigadeView(teams) {
    return <div className="tradesWindow__top">
      <InGameValueCard
        title={"Команда"} isEditable={true} selectData={teams} height={40} type={1}
        subtype={2}
        onChange={value => {
          this.setState({
            selectedTeam: value || 0
          });
        }}
      />

      <div className="filler" style={{marginTop: "20px"}}/>
      <InGameValueCard
        title={"Место"} isEditable={true}
        selectData={["Анино", 'Коршуново', "Архиповка", "Озёрная", 'Депо по ремонту электровозов', "Депо по ремонту тепловозов", "Ремонт инфраструктуры", "Диспетчерская"]}
        height={40} type={1} subtype={2}
        onChange={value => {
          let data = this.state.rentBrigade;
          data.type = PlaceData[value || 0].type;
          data.id = PlaceData[value || 0].id;
          this.setState({
            rentBrigade: data
          });
        }}
      />
      <InGameValueCard
        title={"Цена (млн)"} maxValue={1000} minValue={0} isEditable={true} value={1000000} height={40}
        type={1} subtype={1}
        onChange={value => {
          let data = this.state.rentBrigade;
          data.cost = (parseInt(value) * MIL) || 0;
          this.setState({
            rentBrigade: data
          });
        }}
      />
      <InGameValueCard
        title={"Срок"} isEditable={true} minValue={0} value={10} height={40} type={1} subtype={2}
        onChange={value => {
          let data = this.state.rentBrigade;
          data.days = parseInt(value) || 0;
          this.setState({
            rentBrigade: data
          });
        }}
      />
      <InGameValueCard
        title={"Количество бригад"} isEditable={true} minValue={0} value={1000000} height={40} type={1}
        subtype={1}
        onChange={value => {
          let data = this.state.rentBrigade;
          data.count = parseInt(value) || 0;
          this.setState({
            rentBrigade: data
          });
        }}
      />
    </div>
  }

  buildRentPlaceView(teams) {
    let clients = [];
    let places = GameData.CurrentModeratorGameDatas[this.props.teams[this.state.selectedTeam].uuid].getStationByID(this.state.rentStationPlace.station).clientPlaces;
    Object.keys(places).forEach(client => {
      clients.push(CLIENT_NAMES[client] ?? "Прочее")
    })
    return <div className="tradesWindow__top">
      <InGameValueCard
        title={"Команда"} isEditable={true} selectData={teams} height={40} type={1}
        subtype={2}
        onChange={value => {
          this.setState({
            selectedTeam: value || 0
          });
        }}
      />

      <div className="filler" style={{marginTop: "20px"}}/>
      <InGameValueCard
        title={"Станция"} isEditable={true}
        selectData={["Анино", 'Коршуново', "Архиповка", "Озёрная"]} height={40}
        type={1} subtype={2}
        onChange={value => {
          let data = this.state.rentStationPlace;
          data.station = value || 0;
          this.setState({
            rentStationPlace: data
          });
        }}
      />
      <InGameValueCard
        title={"Клиент"} isEditable={true}
        selectData={clients} height={40}
        type={1} subtype={1}
        onChange={value => {
          let data = this.state.rentStationPlace;
          data.client = Object.keys(places)[value || 0];
          this.setState({
            rentStationPlace: data
          });
        }}
      />
      <InGameValueCard
        title={"Срок"} isEditable={true} minValue={0} value={10} height={40} type={1} subtype={2}
        onChange={value => {
          let data = this.state.rentStationPlace;
          data.days = parseInt(value) || 0;
          this.setState({
            rentStationPlace: data
          });
        }}

      />
      <InGameValueCard
        title={"Количество мест"} isEditable={true} minValue={0} value={10} height={40} type={1}
        subtype={1}
        onChange={value => {
          let data = this.state.rentStationPlace;
          data.count = parseInt(value) || 0;
          this.setState({
            rentStationPlace: data
          });
        }}
      />
      <InGameValueCard
        title={"Цена (млн)"} maxValue={1000} minValue={0} isEditable={true} value={1000000} height={40}
        type={1} subtype={2}
        onChange={value => {
          let data = this.state.rentStationPlace;
          data.cost = (parseInt(value) * MIL) || 0;
          this.setState({
            rentStationPlace: data
          });
        }}
      />
    </div>
  }

  buildCraftOrderView(teams) {
    return <div className="tradesWindow__top">
      <InGameValueCard
        title={"Команда"} isEditable={true} selectData={teams} height={40} type={1}
        subtype={2}
        onChange={value => {
          this.setState({
            selectedTeam: value || 0
          });
        }}
      />

      <div className="top-table">
        <InGameValueCard title={"Заказчик"} value={0} height={40} type={0} subtype={0}

        />
        <div className="no-value">
          <InGameValueCard title={"Груз"} value={0} height={40} type={1} subtype={0}

          />
        </div>
        <InGameValueCard
          className="no-title" isEditable={true} value={"Преподаватель"}
          valueType={"text"}
          onChange={value => {
            let data = this.state.orderData;
            data.clientName = value;
            this.setState({
              orderData: data
            });
          }} height={40} type={1} subtype={1}/>
        <InGameValueCard
          className="no-title" isEditable={true} value={"Спиннеры"}
          valueType={"text"}
          onChange={value => {
            let data = this.state.orderData;
            data.name = value;
            this.setState({
              orderData: data
            });
          }} height={40} type={1} subtype={1}/>
      </div>

      <InGameValueCard title={"Тоннаж"} isEditable={true} minValue={0} value={10} onChange={value => {
        let data = this.state.orderData;
        data.weight = parseFloat(value) || 0;
        this.setState({
          orderData: data
        });
      }} height={40} type={1} subtype={2}/>
      <InGameValueCard
        title={"Тариф за тонну"} minValue={0} maxValue={300} isEditable={true} value={10}
        onChange={value => {
          let data = this.state.orderData;
          data.cost = parseInt(value) || 0;
          this.setState({
            orderData: data
          });
        }} height={40} type={1} subtype={1}/>
      <InGameValueCard
        className="bigTexts"
        title={"Первая подача клиенту порожних вагонов под погрузку на станции отправления (День недели)"}
        selectData={DayData}
        isEditable={true} value={10} onChange={value => {
        let data = this.state.orderData;
        data.day = ((value || 0) + 2) % 4;
        data.year = Math.floor(((value || 0) + 2) / 4);
        this.setState({
          orderData: data
        });
      }} height={56} type={1} subtype={2}/>
      <InGameValueCard
        className="bigTexts"
        title={"Поставка клиенту груженых вагонов на станцию прибытия (День недели)"}
        selectData={DayData}
        isEditable={true} value={10} onChange={value => {
        let data = this.state.orderData;
        data.termDelivery = (value || 0) + 2 - this.state.orderData.day - this.state.orderData.year * 4;
        this.setState({
          orderData: data
        });
      }} height={56} type={1} subtype={1}/>


      <InGameValueCard
        title={"Станция отправления"} isEditable={true}
        selectData={["Анино", 'Коршуново', "Архиповка", "Озёрная"]} height={40}
        type={1} subtype={2}

        onChange={value => {
          let data = this.state.orderData;
          data.fromId = value || 0;
          this.setState({
            orderData: data
          });
        }}
      />
      <InGameValueCard
        title={"Станция назначения"} isEditable={true}
        selectData={["Анино", 'Коршуново', "Архиповка", "Озёрная"]} height={40}
        type={1} subtype={1}
        onChange={value => {
          let data = this.state.orderData;
          data.toId = value || 0;
          this.setState({
            orderData: data
          });
        }}
      />

      <InGameValueCard
        title={"Кредит (%)"} minValue={0} isEditable={true} value={"99%"} height={40} type={1}
        subtype={2}
        onChange={value => {
          let data = this.state.orderData;
          data.credit = ((value || 0) / 100) || 0;
          this.setState({
            orderData: data
          });
        }}
      />
    </div>
  }

  buildSellTrainCarView(teams) {
    return <div className="tradesWindow__top">
      <InGameValueCard
        title={"Команда"} isEditable={true} selectData={teams} height={40} type={1}
        subtype={2}
        onChange={value => {
          this.setState({
            selectedTeam: value || 0
          });
        }}
      />

      <div className="filler" style={{marginTop: "20px"}}/>
      <InGameValueCard
        title={"Станция"} isEditable={true}
        selectData={["Анино", 'Коршуново', "Архиповка", "Озёрная"]} height={40}
        type={1} subtype={2}
        onChange={value => {
          let data = this.state.sellTrainCarData;
          data.stationId = value || 0;
          this.setState({
            sellTrainCarData: data
          });
        }}
      />
      <InGameValueCard
        title={"Цена (млн)"} maxValue={1000} minValue={0} isEditable={true} value={1000000} height={40}
        type={1} subtype={1}
        onChange={value => {
          let data = this.state.sellTrainCarData;
          data.cost = (parseInt(value) * MIL) || 0;
          this.setState({
            sellTrainCarData: data
          });
        }}
      />
      <InGameValueCard
        title={"Количество вагонов"} isEditable={true} minValue={0} value={1000000} height={40} type={1}
        subtype={1}
        onChange={value => {
          let data = this.state.sellTrainCarData;
          data.count = parseInt(value) || 0;
          this.setState({
            sellTrainCarData: data
          });
        }}
      />
    </div>
  }

  buildRedemtionTrainCarView(teams) {
    return <div className="tradesWindow__top">
      <InGameValueCard
        title={"Команда"} isEditable={true} selectData={teams} height={40} type={1}
        subtype={2}
        onChange={value => {
          this.setState({
            selectedTeam: value || 0
          });
        }}
      />

      <div className="filler" style={{marginTop: "20px"}}/>
      <InGameValueCard
        title={"Станция"} isEditable={true}
        selectData={["Анино", 'Коршуново', "Архиповка", "Озёрная"]} height={40}
        type={1} subtype={2}
        onChange={value => {
          let data = this.state.redemptionTrainCarData;
          data.stationId = value || 0;
          this.setState({
            redemptionTrainCarData: data
          });
        }}
      />
      <InGameValueCard
        title={"Цена (млн)"} maxValue={1000} minValue={0} isEditable={true} value={1000000} height={40}
        type={1} subtype={1}
        onChange={value => {
          let data = this.state.redemptionTrainCarData;
          data.cost = (parseInt(value) * MIL) || 0;
          this.setState({
            redemptionTrainCarData: data
          });
        }}
      />
      <InGameValueCard
        title={"Количество вагонов"} isEditable={true} minValue={0} value={1000000} height={40} type={1}
        subtype={1}
        onChange={value => {
          let data = this.state.redemptionTrainCarData;
          data.count = parseInt(value) || 0;
          this.setState({
            redemptionTrainCarData: data
          });
        }}
      />
    </div>
  }

  buildRentTrainCarView(teams) {
    return <div className="tradesWindow__top">
      <InGameValueCard
        title={"Команда"} isEditable={true} selectData={teams} height={40} type={1}
        subtype={2}
        onChange={value => {
          this.setState({
            selectedTeam: value || 0
          });
        }}
      />

      <div className="filler" style={{marginTop: "20px"}}/>
      <InGameValueCard
        title={"Станция"} isEditable={true}
        selectData={["Анино", 'Коршуново', "Архиповка", "Озёрная"]} height={40}
        type={1} subtype={2}
        onChange={value => {
          let data = this.state.rentTrainCarData;
          data.stationId = value || 0;
          this.setState({
            rentTrainCarData: data
          });
        }}
      />
      <InGameValueCard
        title={"Срок"} isEditable={true} minValue={0} value={10} height={40} type={1} subtype={2}
        onChange={value => {
          let data = this.state.rentTrainCarData;
          data.days = parseInt(value) || 0;
          this.setState({
            rentTrainCarData: data
          });
        }}

      />
      <InGameValueCard
        title={"Цена (млн)"} maxValue={1000} minValue={0} isEditable={true} value={1000000} height={40}
        type={1} subtype={1}
        onChange={value => {
          let data = this.state.rentTrainCarData;
          data.cost = (parseInt(value) * MIL) || 0;
          this.setState({
            rentTrainCarData: data
          });
        }}
      />
      <InGameValueCard
        title={"Количество вагонов"} isEditable={true} minValue={0} value={1000000} height={40} type={1}
        subtype={1}
        onChange={value => {
          let data = this.state.rentTrainCarData;
          data.count = parseInt(value) || 0;
          this.setState({
            rentTrainCarData: data
          });
        }}
      />
    </div>
  }
}
